import { Component, OnInit } from '@angular/core';
import { TaskHandler } from '../tasks/TaskHandler';
import { HeaderActionsService } from './common/sub-header/header-actions.service';


@Component({
    selector: 'Empty',
    templateUrl: 'empty.template.html'
})
export class emptyComponent extends TaskHandler implements OnInit {

    constructor(
        private headerActionsService: HeaderActionsService) {
        super();
    }

    ngOnInit(): void {

        this.headerActionsService.addDivider();
        this.subscribe(
            this.headerActionsService
                .addAction(
                    'General.back',
                    'fas fa-chevron-left',
                    'btn-outline-secondary',
                    true
                )
            , success => {
                this.uiService.routeBack();
            });
        this.waitService.cancelWaiting();

    }
}